import axios from "axios";
import { TOURNAMENT_DATA_URL, TOURNAMENT_URL } from "../ApiConstant";

export const tournamentEligibilityLoading = () => {
  return {
    type: "TOURNAMENT_ELIGIBILITY_LOADING",
  };
};

export const tournamentEligibilitySuccess = ({
  eligible,
  eligibility,
  tournamentId,
}) => {
  return {
    type: "TOURNAMENT_ELIGIBILITY_SUCCESS",
    eligible,
    eligibility,
    tournamentId,
  };
};

export const tournamentEligibilityError = (error) => {
  return {
    type: "TOURNAMENT_ELIGIBILITY_ERROR",
    error,
  };
};

export const clearTournamentEligibility = () => {
  return {
    type: "TOURNAMENT_ELIGIBILITY_CLEAR",
  };
};

const getTournamentIdFromResponse = (data) => {
  if (!Array.isArray(data) || data.length === 0) return null;
  const active = data.find((x) => x && x.status === 1 && x.id != null);
  const fallback = data.find((x) => x && x.id != null);
  return (active ?? fallback)?.id ?? null;
};

export const fetchTournamentEligibility = () => {
  return async (dispatch) => {
    dispatch(tournamentEligibilityLoading());

    try {
      const resp = await axios.get(TOURNAMENT_URL);
      const tournamentId = getTournamentIdFromResponse(resp?.data);

      if (tournamentId == null) {
        dispatch(
          tournamentEligibilitySuccess({
            eligible: false,
            eligibility: [],
            tournamentId: null,
          })
        );
        return;
      }

      const tournamentDataResp = await axios.get(
        `${TOURNAMENT_DATA_URL}${tournamentId}`
      );
      const eligibility = tournamentDataResp?.data?.eligibility;
      const eligible = Array.isArray(eligibility) && eligibility.length > 0;

      dispatch(
        tournamentEligibilitySuccess({
          eligible,
          eligibility: Array.isArray(eligibility) ? eligibility : [],
          tournamentId,
        })
      );
    } catch (error) {
      dispatch(tournamentEligibilityError(error));
    }
  };
};
